import { CreditCardItemForm } from '@webapp/modules/accounts-payable/components/CreditCardItemForm'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { useEditCreditCardItemFormPresenter } from './useEditCreditCardItemFormPresenter'

export interface IEditCreditCardItemFormPresenterProps {
  /** Prefill source — no fetch; supplied by the parent list (BHV-018) */
  item: CreditCardItem
  /** FS decides mode from item.isEditable — matched items open 'view' (BHV-019) */
  mode: 'edit' | 'view'
  onSuccess: (item: CreditCardItem) => void
  onCancel: () => void
}

// Form content only — the ModalDialog wrapper is FS-owned.
export const EditCreditCardItemFormPresenter = ({
  item,
  mode,
  onSuccess,
  onCancel,
}: IEditCreditCardItemFormPresenterProps) => {
  const {
    states: { isUpdating },
    methods: { onSubmit },
  } = useEditCreditCardItemFormPresenter({ item, mode, onSuccess })

  return (
    <CreditCardItemForm
      mode={mode}
      item={item}
      isSaving={isUpdating}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

EditCreditCardItemFormPresenter.displayName = 'EditCreditCardItemFormPresenter'
